/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import borders from "assets/theme/theme-light/base/borders";
import colors from "assets/theme/theme-light/base/colors";
import boxShadows from "assets/theme/theme-light/base/boxShadows";
import rgba from "assets/theme/functions/rgba";
import pxToRem from "assets/theme/functions/pxToRem";
import linearGradient from "assets/theme/functions/linearGradient";

const { borderRadius } = borders;
const { green, white } = colors;
const { colored, md } = boxShadows;

const tabs = {
  styleOverrides: {
    root: {
      position: "relative",
      backgroundColor: rgba(white.main, 0.9),
      minHeight: "unset",
      padding: pxToRem(8),
      margin: pxToRem(10),
      marginTop: pxToRem(0),
      marginBottom: pxToRem(10),
      boxShadow: md,
      borderRadius: borderRadius.lg,
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    indicator: {
      width: "100%",
      backgroundImage: linearGradient(green.main, green.state),
      height: "100%",
      transition: "all 200ms ease",
      borderRadius: borderRadius.md,
      boxShadow: colored.green,
    },
  },
};

export default tabs;
